module.exports = __webpack_public_path__ + "img/dp1.726aa7a4.jpg";